import { Link } from "@tanstack/react-router";

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-border bg-background py-2">
      <div className="container mx-auto max-w-7xl px-4">
        <div className="flex flex-row items-center justify-between gap-4">
          <Link
            to="/"
            className="flex items-center transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
          >
            <img
              src="/logo-horizontal.svg"
              alt="Apptly Health"
              className="h-16 w-auto md:h-20"
            />
          </Link>
          <div className="flex items-center space-x-6 text-sm text-muted-foreground">
            <a
              href={import.meta.env.VITE_PRIVACY_POLICY}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            >
              Privacy Policy
            </a>
            <a
              href={import.meta.env.VITE_TERMS_OF_SERVICE}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            >
              Terms of Service
            </a>
            <a
              href="https://apptlyhealth.com/contact-support/"
              className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
